export type TabKey = "today" | "log" | "diary" | "train" | "body" | "routine" | "coach";

const TABS: { key: TabKey; label: string; icon: preact.JSX.Element }[] = [
  { key: "today", label: "Today", icon: <circle cx="12" cy="12" r="8" /> },
  { key: "log", label: "Log", icon: <><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></> },
  { key: "diary", label: "Diary", icon: <><rect x="5" y="4" width="14" height="16" rx="2" /><line x1="9" y1="9" x2="15" y2="9" /><line x1="9" y1="13" x2="15" y2="13" /></> },
  { key: "train", label: "Train", icon: <><path d="M6 8v8M18 8v8M3 10v4M21 10v4" /><line x1="6" y1="12" x2="18" y2="12" /></> },
  { key: "body", label: "Body", icon: <><path d="M4 18 L9 11 L13 14 L20 6" /><circle cx="20" cy="6" r="1.4" /></> },
  { key: "routine", label: "Routine", icon: <><circle cx="12" cy="12" r="8" /><path d="M12 8v4l3 2" /></> },
  { key: "coach", label: "Coach", icon: <><path d="M21 11.5a8.5 8.5 0 0 1-12.5 7.5L4 20l1-4.5A8.5 8.5 0 1 1 21 11.5z" /></> },
];

export function TabBar({ active, onChange }: { active: TabKey; onChange: (k: TabKey) => void }) {
  return (
    <nav class="tabbar">
      {TABS.map((t) => (
        <button key={t.key} class={active === t.key ? "active" : ""} onClick={() => onChange(t.key)}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">{t.icon}</svg>
          {t.label}
        </button>
      ))}
    </nav>
  );
}
